"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSeasonSchema = void 0;
exports.EventSeasonSchema = {
    "$id": "https://www.redbull.com/schemas/content/event-seasons.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "EventSeason",
    "description": "An event season groups multiple event profiles that are related to the same event series. (e.g. Red Bull Cliff Diving Season 2024)",
    "properties": {
        "type": {
            "enum": [
                "rrn:content:event-seasons"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:event-seasons:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        },
        "attributes": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "author": {
                    "type": "string",
                    "deprecated": true,
                    "deprecationReason": "This property will be removed from the abstract with the next release",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "callToActions": {
                    "type": "array",
                    "items": {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/call-to-action.schema.json"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "contentClassificationTerms": {
                    "description": "User defined terms to classify content.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "contextualTitle": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/contextual.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "customProperties": {
                    "description": "Custom properties which can be added to content-resources (E.g. configuration of theme properties, etc.) Note that custom properties are not governed by the content-schema. It is therefore not guaranteed that certain custom properties exist. We also do not migrate custom properties if the schema evolves.",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/key-value.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "geoBlockedIn": {
                    "description": "Countries in which the resource is geo-blocked. Resembled through two-letter ISO_3166-1_alpha-2 country codes",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "isPlaceholder": {
                    "description": "Marks a resource as placeholder.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "legacyContentId": {
                    "description": "RB2 content ID.",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "mainPartner": {
                    "description": "Represents the main partner associated with the resource",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/featured-partners.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "planningClassification": {
                    "description": "Content classification rating from the scheduling team.",
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "A",
                            "B",
                            "C",
                            "D",
                            "E"
                        ]
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "publishedDate": {
                    "description": "The initial published date of the resource. This date is set automatically if the resource is moved from `draft` to `published` state the first time.",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "searchTerms": {
                    "description": "A list of search terms which result in a full-match of a given content resource.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "subHeading": {
                    "description": "An additional title of a resource. e.g. films often have subheadings like `Streif - One Hell of a Ride` where `One Hell of a Ride` would be the subHeading",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "teaser": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "title": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "uriSlug": {
                    "type": "string",
                    "description": "Must be unique across content GUID+language and may be reused for different locales"
                },
                "url": {
                    "description": "If provided, the URL should be used instead of dynamic routes (based on urislug) to link to the content resource (can be used to add resources which are presented outside the RB3 platform)",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/web-link.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "usageRestrictions": {
                    "description": "Restrictions describing where the specific resource should NOT be used.",
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "maturity:NR",
                            "maturity:UR",
                            "no-monetization",
                            "no-stand-alone-display"
                        ]
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "description": {
                    "description": "A list of text blocks containing textual season information. Not all elements may be presented to the user by default. Keep the first textualArtefactContainer concise (recommended less than 250 chars)",
                    "type": "array",
                    "items": {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
                    }
                },
                "label": {
                    "type": "string",
                    "description": "The label of the season, e.g. `2018`. Shown on tabs."
                },
                "seasonNumber": {
                    "type": "integer",
                    "description": "The numerical season number (used for sorting) E.g. `2018`"
                }
            },
            "required": [
                "title",
                "label",
                "seasonNumber",
                "uriSlug"
            ]
        },
        "relationships": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "contentCollections": {
                    "type": "object",
                    "description": "Lists all content-collections that are automatically assigned through the tag tree. Collections are automatically assigned if the `autoAssign` attribute of the collection is set to `true` and one of the tags set on the content resource is also available on the content collection's `mappedTags` relationship.",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/collections.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "displayTags": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "deprecated": true,
                    "deprecationReason": "Display-tags are replaced with content-collections. Use relationship `contentCollections` instead. For further details check out http://bit.ly/2F9w93H",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/tags.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "embeddedResources": {
                    "type": "object",
                    "description": "All resources embedded in attributes",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "featuredMedia": {
                    "type": "object",
                    "description": "Content element (usually images) used for featuring of a content element",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                                    },
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/preview-clips.schema.json"
                                    },
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                                    }
                                ]
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "headerMedia": {
                    "type": "object",
                    "description": "Content piece shown in the header of another content element (e.g. image shown in the header of a story)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "anyOf": [
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/episode-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/films.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/recap-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/trailer-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/video-channels.schema.json"
                                }
                            ]
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "locations": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/locations.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "logo": {
                    "type": "object",
                    "description": "Optional logo for a content piece (e.g. logo for an event-profile)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "master": {
                    "type": "object",
                    "description": "Reference to the master resource holding all translations",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "partners": {
                    "type": "object",
                    "description": "Contains a list of additional partners or sponsors associated with the resource",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "pseudoGroups": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/tags.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "relatedContents": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "socialMediaImage": {
                    "type": "object",
                    "description": "Image that represents a content resource on social media platforms (og:image)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "tags": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "translatedFrom": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "translations": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "events": {
                    "type": "object",
                    "description": "All events of the season",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/event-profiles.schema.json"
                            }
                        }
                    }
                },
                "series": {
                    "type": "object",
                    "description": "The event-series the event-season belongs to.",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/content/event-series.schema.json"
                        }
                    }
                }
            },
            "required": [
                "series"
            ]
        },
        "links": {
            "type": "object",
            "additionalProperties": {
                "type": [
                    "object",
                    "string"
                ],
                "description": "A link **MUST** be represented as either: a string containing the link's URL or a link object.",
                "oneOf": [
                    {
                        "description": "A string containing the link's URL.",
                        "type": "string",
                        "format": "uri-reference"
                    },
                    {
                        "type": "object",
                        "required": [
                            "href"
                        ],
                        "properties": {
                            "href": {
                                "description": "A string containing the link's URL.",
                                "type": "string",
                                "format": "uri-reference"
                            },
                            "meta": {
                                "description": "Non-standard meta-information that can not be represented as an attribute or relationship.",
                                "type": "object",
                                "additionalProperties": true
                            }
                        }
                    }
                ]
            }
        },
        "meta": {
            "additionalProperties": true,
            "type": "object",
            "properties": {
                "createdBy": {
                    "description": "User or system that initially created a resource",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "dateCreated": {
                    "description": "DateTime when a resource was created",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "dateUpdated": {
                    "description": "DateTime when a resource was last changed. Every change to a resource results in a new dateUpdated",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "externalReference": {
                    "description": "Reference to external applications (e.g. if the asset was imported)",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/external-reference.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "foreignKeys": {
                    "description": "Foreign keys of this asset in other systems (e.g. if the asset was imported / links to media asset system)",
                    "type": "array",
                    "deprecated": true,
                    "deprecationReason": "This property will be removed anytime soon. However, the information won't be lost but migrated to `externalReference`",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "language": {
                    "description": "The language the resource is written in",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "locale": {
                    "description": "The locale of the resource.",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "machineTranslated": {
                    "description": "Indicates if the asset was translated by machine/AI.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "published": {
                    "description": "Indicator if resource is published.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "region": {
                    "description": "The region or country the resource was published for (e.g. INT for international region, AT for Austria)",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "spaces": {
                    "description": "Content-spaces a resource is assigned to",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "status": {
                    "description": "Represents the current lifecycle state of the resource. The status can either be `DRAFT`, `PUBLISHED`, or `UNPUBLISHED`.",
                    "type": "string",
                    "enum": [
                        "DRAFT",
                        "PUBLISHED",
                        "UNPUBLISHED"
                    ],
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "updatedBy": {
                    "description": "User or system that updated the resource the last time",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                }
            }
        }
    },
    "type": "object",
    "required": [
        "type",
        "id",
        "attributes",
        "relationships"
    ]
};
//# sourceMappingURL=data:application/json;base64,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